import redbag1a from "../assets/Projects/RedBagNew/redbag1a.png";
import retriever from "../assets/Projects/Retriever/retriever.png";
import santa from "../assets/Projects/RedBagOld/santa.png";
import folder from "../assets/Projects/Wireframes/folder.png";
import page from "../assets/Projects/SleepyWoods/page.png";

export const ProjectList = [
  {
    name: "Red Bags KC Database Redesign",
    image: redbag1a,
    skills:
      "AWS Amplify, AppSync, JavaScript, HTML, CSS, React, Figma, GraphQL, NodeJS",
    color: "#DE1A1A",
  },
  {
    name: "Red Bags KC Database Version 1",
    image: santa,
    skills:
      "AWS Amplify, AppSync, JavaScript, HTML, CSS, React, Figma, GraphQL, NodeJS",
    overview:
      "Red Bag KC is a non-profit organization that has been serving the community for over 30 years, ensuring that every child, regardless of their socio-economic background, experiences the joy of opening gifts at Christmas. I’ve been involved with this organization for over a decade, but the heart of the charity lies in the dedication of six incredible women. Their process was simple yet outdated—relying on pen, paper, and index cards to manage everything. As a recent computer science graduate, I saw firsthand the challenges they faced—digging through stacks of papers, index cards, and binders just to find a child’s information. I knew technology could streamline their workflow and make their efforts more efficient. Convincing them wasn’t easy (some weren’t even familiar with opening a web browser), but I assured them that an interactive database would drastically simplify their work. So, in October 2022, I set out to modernize their system. This is what I created.",
    color: "#A2D2FF",
  },
  {
    name: "Retriever App",
    image: retriever,
    skills: "React Native, JavaScript, Node.js, MongoDB",
    overview:
      "For my senior year capstone project, I worked on developing a unified platform for lost and found items, aiming to simplify the process of returning belongings to their rightful owners. This app enables users to post alerts in their surrounding area, making it easier to locate and reclaim lost items. Our goal was to modernize and streamline the traditional Lost & Found system, creating a more efficient and accessible solution for reconnecting people with their possessions.",
    color: "#3e497a",
  },

  {
    name: "Sleepy Woods",
    image: page,
    skills: "Unity, C#",
    overview:
      "This was a college course where I collaborated on a team of 11, consisting of 5 developers, 3 designers, a music major, and 2 journalism majors. The objective was to leverage our diverse skill sets to create a fully functional game, combining technical, artistic, and storytelling expertise. In this 2D cooperative puzzle-platformer, players control Charlie (a bear) and Charlemagne (a bird) as they work together to prepare for winter—Charlie getting ready for hibernation and Charlemagne preparing to migrate. To win, players must overcome obstacles and collect essential items, utilizing teamwork and problem-solving skills to complete the journey.",
    color: "#E9D35B",
  },
];
